<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="交易对抄底配置" name="first">
        <trade-configs v-if="activeName === 'first'"></trade-configs>
      </el-tab-pane>
      <el-tab-pane label="平台抄底配置(多)" name="second">
        <globbing-configs-long v-if="activeName === 'second'"></globbing-configs-long>
      </el-tab-pane>
      <el-tab-pane label="平台抄底配置(空)" name="third">
        <globbing-configs-short v-if="activeName === 'third'"></globbing-configs-short>
      </el-tab-pane>
      <el-tab-pane label="K线波动配置" name="fourth">
        <kline-wave-configs v-if="activeName === 'fourth'"></kline-wave-configs>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style scoped>
  ::v-deep .el-tabs__header {
    padding: 10px 10px 0 10px;
    margin-bottom: 5px;
  }
</style>

<script>
import TradeConfigs from '@/components/platformPairKlineConfig/TradeConfigs.vue'
import GlobbingConfigsLong from '@/components/platformGlobbingKlineConfig/GlobbingConfigsLong.vue'
import GlobbingConfigsShort from '@/components/platformGlobbingKlineConfig/GlobbingConfigsShort.vue'
import KlineWaveConfigs from '@/components/klineWaveConfigs/KlineWaveConfigs.vue'

export default {
  name: 'Nav',
  components: { GlobbingConfigsLong, GlobbingConfigsShort, TradeConfigs, KlineWaveConfigs },
  data () {
    return {
      activeName: 'first'
    }
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    }
  }
}

</script>
